module.exports = __webpack_public_path__ + "media/images/members/zaida_vila_carneiro-c63b8d17d187e4193194cc848dfe00bd.jpg";